export default __webpack_public_path__ + "static/media/email.b3f34917.svg";